import React, {useMemo} from 'react'
import {useHistory} from "react-router";
import _ from 'lodash'

import {usePersistedState} from 'hooks'
import entities from 'reduxStore/entityKeys'

import {BackendJob, HygienistBackendJob} from 'components/EditJob'
import {JobList} from "components/JobList";
import {Filters, SortingOption} from './types'
import {UploadResumeButton} from "components/UploadResumeButton";

import {
  Container,
  StyledArrowDownwardIcon,
  StyledFilterListIcon,
  Title,
  TitleContentButton,
  TitleContentContainer
} from './AvailablePositions.styles'

interface AvailablePositionsProps {
  jobs: HygienistBackendJob[]
  sortBy: SortingOption
  filterBy: Filters
  onSortButtonClick: () => void
  onFilterButtonClick: () => void
}

const getFinalJobList = (jobs: HygienistBackendJob[], sortBy: SortingOption, filterBy: Filters) => {
  const sortValues = {
    [SortingOption.datePosted]: 'createdOn',
    [SortingOption.startDate]: 'startDate',
    [SortingOption.distance]: 'distanceObj.distance.value',
    [SortingOption.applied]: 'isApplied',
  }
  let jobListFiltered = jobs;

  if (filterBy.basis) {
    jobListFiltered = jobs.filter(({basis}) => filterBy.basis && basis === filterBy.basis.id)
  }
  if (filterBy.availability) {
    const filterDaysOfWeekDictionary: { [key: number]: boolean } = filterBy.availability.reduce((acc, {id}) => ({
      ...acc,
      [id]: true
    }), {});
    jobListFiltered = jobListFiltered.filter(({daysOfWeek}) => {
      const parsedDaysOfWeek = daysOfWeek.split(',').map(d => +d) || [];
      return parsedDaysOfWeek.some((status, index) => status === 1 && filterDaysOfWeekDictionary[index]);
    })
  }

  let jobListSorted;
  if (sortBy === SortingOption.datePosted || sortBy === SortingOption.applied) {
    jobListSorted = _.sortBy(jobListFiltered, [sortValues[sortBy]]).reverse();
  } else {
    jobListSorted = _.sortBy(jobListFiltered, [sortValues[sortBy]]);
  }

  return jobListSorted
}

const AvailablePositions = ({
                              jobs,
                              filterBy,
                              sortBy,
                              onSortButtonClick,
                              onFilterButtonClick
                            }: AvailablePositionsProps) => {
  const history = useHistory();

  const hygienistUser: any = usePersistedState({
    entityName: entities.user
  })[0]

  const finalJobList = useMemo(() => getFinalJobList(jobs, sortBy, filterBy), [jobs, sortBy, filterBy])

  const onJobClick = (job: HygienistBackendJob | BackendJob) => {
    history.push({
      pathname: 'jobPostDetails',
      state: {
        job,
        hygienistUser
      },
    })
  }

  return (
    <Container>
      <TitleContentContainer>
        <Title>Permanent Job Board</Title>
      </TitleContentContainer>
      <TitleContentContainer>
        <TitleContentButton onClick={onSortButtonClick} className='no-fastclick'>
          <StyledArrowDownwardIcon/>
          <span>{sortBy}</span>
        </TitleContentButton>
        <TitleContentButton onClick={onFilterButtonClick} className='no-fastclick'>
          <StyledFilterListIcon/>
          <span>Filter</span>
        </TitleContentButton>
      </TitleContentContainer>
      <UploadResumeButton/>
      <JobList jobs={finalJobList} onJobClick={onJobClick} isHygienist={true}/>
    </Container>
  )
}

export default AvailablePositions;
